import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-pilates': {
			// ?safe&utm_source=FB&country=US&area=activity-female-pilates&exp=web_pilates_gamification_progress~1
			funnel: {
				id: 'ob-pilates-gamification-progress',
				locale: ['en'],
			},
		},
	},
]

export default config
